/* eslint-disable jsx-a11y/media-has-caption */
import * as React from "react";

import { useState, useEffect } from "react";
import { useAppSelector } from "../../../../store/hooks";

import { ActiveTabEnum, AudioEnum } from "../../../../enums";
import { getAudio } from "../../../../utils/AudioUtils";
import store from "../../../../store/store";

const AudioPlayerBackground: React.FC = () => {
  const drawStarted = useAppSelector((state) => state.tab.drawStarted);
  const activeTab = useAppSelector((state) => state.tab.activeTab);
  const [isDrawBackgroundMusic, setIsDrawBackgroundMusic] = useState(false);
  const isMute = useAppSelector((state) => state.audio.isMute);

  useEffect(() => {
    if (
      activeTab === ActiveTabEnum.DRAW &&
      (drawStarted || store.getState().tab.spinAgainTimeout > 0)
    ) {
      setIsDrawBackgroundMusic(true);
    }
    if (activeTab === ActiveTabEnum.PLAY) {
      setIsDrawBackgroundMusic(false);
    }
  }, [drawStarted, activeTab]);

  return (
    <>
      {!isDrawBackgroundMusic && (
        <audio autoPlay loop muted={isMute}>
          <source src={getAudio(AudioEnum.BACKGROUND_BET)} />
        </audio>
      )}
      {isDrawBackgroundMusic && (
        <audio autoPlay loop muted={isMute}>
          <source src={getAudio(AudioEnum.BACKGROUND_DRAW)} />
        </audio>
      )}
    </>
  );
};

export default AudioPlayerBackground;
